export function useFirefox() {
    return navigator.userAgent.toLowerCase().includes("firefox");
}
